import React from 'react';
import PropTypes from 'prop-types';
import { Div, Link, Flex, Icon, FormText } from 'ui';
import { FormattedMessage } from 'react-intl';

const ShipToComponent = ({ shipTo = {}, readOnly = false }) => {
  const { name, houseNumber, street, city, postalCode } = shipTo;
  const addComma = address => address ? `${address}, ` : '';

  return (
    <Div marginBottom={10}>
      {!shipTo || !Object.keys(shipTo).length ?
        <>
          <FormText><FormattedMessage id='partners.NO_SHIPTO' /></FormText>
          {!readOnly && <Link onClick={() => window.scrollTo(0, 250)}>
            <Icon type='chevron-up' />
            <FormattedMessage id='partners.SCROLL_TO_CHANGE' />
          </Link>}
        </> :
        <>
          <Flex jcsb maxWidth='400px'>
            {name}{' '}
            {!readOnly && <Link onClick={() => window.scrollTo(0, 250)}>
              <Icon type='chevron-up' />
              <FormattedMessage id='partners.SCROLL_TO_CHANGE' />
            </Link>}
          </Flex>
          {(street || houseNumber) &&
            <Div>{`${addComma(`${street || ''} ${houseNumber || ''}`)}
            ${postalCode || ''} ${city || ''}`}</Div>
          }
        </>
      }
    </Div>
  );
};

ShipToComponent.propTypes = {
  shipTo: PropTypes.object,
  readOnly: PropTypes.bool,
};

export default ShipToComponent;
